import menu from './menu';
import menuAdd from './menuAdd';
import menuEdit from './menuEdit';
import group from './group';
import groupRules from './groupRules';
import interviewer from './interviewer';
import relationSchool from './relationSchool';
import specialSchool from './specialSchool';
import formview from '../../../pages/bi/interview/formview';
import interviewStatus from '../../../pages/bi/interview/interviewStatus';
import interviewResult from '../../../pages/bi/interview/interviewResult';

const powerRouter = [
  {
    path: '/menu/:pid?', name: 'menu', component: menu, meta: { c: 'power', a: 'menu' }
  },
  {
    path: '/menuAdd/:pid?', name: 'menuAdd', component: menuAdd, meta: { c: 'power', a: 'menuAdd' }
  },
  {
    path: '/menuEdit/:id', name: 'menuEdit', component: menuEdit, meta: { c: 'power', a: 'menuEdit' }
  },
  {
    path: '/power/group', name: 'group', component: group, meta: { c: 'power', a: 'group' }
  },
  {
    path: '/power/groupRules/:id', name: 'groupRules', component: groupRules, meta: { c: 'power', a: 'groupRules' }
  },
  {
    path: '/power/interviewer', name: 'interviewer', component: interviewer, meta: { c: 'power', a: 'interviewer' }
  },
  {
    path: '/power/relationSchool/:userid', name: 'relationSchool', component: relationSchool, meta: { c: 'power', a: 'relationSchool' }
  },
  {
    path: '/power/specialSchool', name: 'specialSchool', component: specialSchool, meta: { c: 'power', a: 'specialSchool' }
  },
  {
    path: '/bi/interview/formview', name: 'formview', component: formview, meta: { c: 'interview', a: 'formview' }
  },
  {
    path: '/bi/interview/interviewStatus', name: 'interviewStatus', component: interviewStatus, meta: { c: 'interview', a: 'interviewStatus' }
  },
  {
    path: '/bi/interview/interviewResult', name: 'interviewResult', component: interviewResult, meta: { c: 'interview', a: 'interviewResult' }
  },
];

export default powerRouter;

